import request from '@/utils/request'


// 查询产品规格关联列表
export function listGoodsAssociation(query) {
  return request({
    url: '/user/goods-association/list',
    method: 'get',
    params: query
  })
}

// 查询产品规格关联分页
export function pageGoodsAssociation(query) {
  return request({
    url: '/user/goods-association/page',
    method: 'get',
    params: query
  })
}

// 查询产品规格关联详细
export function getGoodsAssociation(data) {
  return request({
    url: '/user/goods-association/detail',
    method: 'get',
    params: data
  })
}

// 新增产品规格关联
export function addGoodsAssociation(data) {
  return request({
    url: '/user/goods-association/add',
    method: 'post',
    data: data
  })
}

// 修改产品规格关联
export function updateGoodsAssociation(data) {
  return request({
    url: '/user/goods-association/edit',
    method: 'post',
    data: data
  })
}

// 删除产品规格关联
export function delGoodsAssociation(data) {
  return request({
    url: '/user/goods-association/delete',
    method: 'post',
    data: data
  })
}
